module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAARCAYAAAAyhueAAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAEQSURBVDiNvdQxTsNAEIXh/9lWokgp0iDlAjRWZC2W6Sm4BUJKQ8UhSO5ARxOJloILcAJksjINBVShcMENiD0UdCSG4ASmfTvfTjOjJMlGQWjXgGP78nWlU7mD9B40FMzMrGqrSQoNxmBlBMowm879w2TbMZ1LK6SLoC0Qx3E/juP+uqwVmiTZqNPtLTrd3iJJstFO0CCoj4EBMFDE0dc8aoPW9fImCKMTAFu+3/6IujQ9x3TZ4L35eb5XFMUrcNj06QpaSXdhbdN1j00qm6Bv0cc8fwImmzRvjDqXjpGu1mXAs5/n+79GofYQzrDVzMRLq0m99x4426S5qVpv1L+jn1fKNJR2cKWMMbJSf3FPPwDTBVdbPJqV0QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/gerenxinxi.png
// module id = C4Rr
// module chunks = 1